import { useSelect, dispatch } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { PanelRow, FormTokenField } from '@wordpress/components';

export default () => {

    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { disable_email_powered_by_text, email_template_powered_by_text, wp_travel_booking_notif_emails, show_wp_travel_utilities, options, modules } = allData;
    const { updateSettings } = dispatch('WPTravel/Admin');
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;


    let notif_emails = '' == wp_travel_booking_notif_emails ? [] : wp_travel_booking_notif_emails;

    let disable_powered_by = 'undefined' != typeof disable_email_powered_by_text ? disable_email_powered_by_text : 'no'
    // if ( 'no' == show_wp_travel_utilities ) {
    //     return <p>{__('WP Travel Utilities is currently disabled please go to Addons Settings to enable it to use custom "To Email" and reload the page.')}</p>
    // }
    if ( ! isActive ) {
        // To hide while disabling from addons settings.
        return <></>;
    }
    return <>
        <PanelRow>
            <label>{_wp_travel.setting_strings.email_tempaltes.to_emails }</label>
            <div className="wp-travel-field-value">
                <FormTokenField 
                    label=""
                    value={ notif_emails } 
                    suggestions={ [] } 
                    onChange={ tokens =>{
                        updateSettings({
                            ...allData,
                            wp_travel_booking_notif_emails: tokens
                        })
                    }}
                />
            </div>
        </PanelRow> 
    </>
}